import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ApiService } from '../../../../utils/services/api.service';
import { NotificationsService } from 'angular2-notifications';
import { CloseGuard, DialogRef, ModalComponent } from 'ngx-modialog';

@Component({
  selector: 'app-free-hotel-modal',
  templateUrl: './free-hotel-modal.component.html',
  styleUrls: ['./free-hotel-modal.component.scss']
})
export class FreeHotelModalComponent implements OnInit, CloseGuard, ModalComponent<any> {
   public formGroup: FormGroup;
  public hotelId;
  public roomId;
  public status;
  public hotelOrgId;


  constructor(private notificationsService: NotificationsService,public apiService: ApiService, public dialog: DialogRef<any>) {
    this.roomId = this.dialog.context.roomId;
    this.hotelOrgId = this.dialog.context.hotelOrgId;
    this.hotelId = this.dialog.context.hotelId;

    this.status = this.dialog.context.status;

  }
  

  ngOnInit() {
    this.formGroup = new FormGroup({
      'desc': new FormControl(null),
    });
  }
  closeModal() {
    this.dialog.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return false;
  }
  action(comment) {
    let data = {
      providerOrganizationId: this.hotelOrgId,
      status: this.status,
      administrativeComment: comment.desc
    }
    this.apiService.updateHotelChanges(this.hotelId,data).subscribe(res => {
      if (res.data.affectedRowCount==1) {
        this.notificationsService.success('Success', 'Update operation is successful!');
        this.dialog.close(res.data);
        this.closeModal()
      }
    },(err)=>{
      this.notificationsService.success('Error', 'Update operation is failed!');
    })
  }

}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/pages/free-hotel-changes/free-hotel-modal/free-hotel-modal.component.ts